import { DragIcon, PlusCircleSVG, TrashBin } from 'common/assets';
import stylesBreakpoint from 'common/styles/styles.breakpoint';
import { FormState, Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import { CustomLabel } from 'components/elements/custom-form-control';
import { Container, HalfContainer } from 'components/styles';
import RoleSelectInput from 'legacy-modules/master/role/components/select-input';
import { FullContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { ApprovalMasterFormType } from './form-type';
import { RolesContainer } from './style';

export default function RolesSection() {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<ApprovalMasterFormType>();
  const [index, setIndex] = React.useState<number>(0);
  const { fields, append, remove, move } = useFieldArray({
    control,
    name: 'approvalDetails',
    keyName: 'customId',
  });
  const onAdd = () => {
    append([
      {
        roleId: '',
      },
    ]);
  };

  const onRemove = (index: number) => {
    remove(index);
  };

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    move(result.source.index, result.destination.index);
  }

  return (
    <Container
      $style={{
        width: '52%',

        gap: '12px',

        [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
          width: '100%',
        },
      }}
    >
      <CustomLabel label={t('common:role')} />
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable
          renderClone={(provided) => (
            <div
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
            >
              <RolesContainer>
                <FullContainer>
                  <Input
                    type="text"
                    name={`approvalDetails[${index}].roleName`}
                  />
                </FullContainer>
                <IconButton buttonType="tertiary" variant="small">
                  <TrashBin />
                </IconButton>
                <IconButton buttonType="tertiary" variant="small">
                  <DragIcon />
                </IconButton>
              </RolesContainer>
            </div>
          )}
          // droppableId="drop"
          droppableId="dropping"
        >
          {(provided) => (
            <FullContainer
              $style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '14px',
              }}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {fields.map((item, idx) => {
                return (
                  <FormState key={item.customId}>
                    {({ editable }) => (
                      <Draggable
                        key={item.customId}
                        draggableId={item.customId}
                        index={idx}
                      >
                        {(dragProvider, snapshot) => (
                          <RolesContainer
                            ref={dragProvider.innerRef}
                            {...dragProvider.draggableProps}
                            {...(!editable && dragProvider.dragHandleProps)}
                          >
                            <FullContainer>
                              <RoleSelectInput
                                name={`approvalDetails[${idx}].roleId`}
                                onAfterDetailChange={(value) =>
                                  setValue(
                                    `approvalDetails.${idx}.roleName`,
                                    value.name,
                                  )
                                }
                              />
                            </FullContainer>

                            {editable && (
                              <>
                                {idx >= 0 && (
                                  <IconButton
                                    buttonType="tertiary"
                                    variant="small"
                                    onClick={() => onRemove(idx)}
                                  >
                                    <TrashBin />
                                  </IconButton>
                                )}
                                <div {...dragProvider.dragHandleProps}>
                                  <IconButton
                                    buttonType="tertiary"
                                    variant="small"
                                    onClick={() => {
                                      setIndex(idx);
                                    }}
                                  >
                                    <DragIcon />
                                  </IconButton>
                                </div>
                              </>
                            )}
                          </RolesContainer>
                        )}
                      </Draggable>
                    )}
                  </FormState>
                );
              })}
              {provided.placeholder}
            </FullContainer>
          )}
        </Droppable>
      </DragDropContext>

      <FormState>
        {({ editable }) =>
          editable ? (
            <HalfContainer>
              <Button
                startEnhancer={(color, size) => (
                  <PlusCircleSVG color={color} size={size} />
                )}
                buttonType="secondary"
                onClick={onAdd}
              >
                {t('common:add_extra', {
                  extra: t('common:role'),
                })}
              </Button>
            </HalfContainer>
          ) : (
            <></>
          )
        }
      </FormState>
    </Container>
  );
}
